import PostsAdapter from './base';

export default class PostTemplate extends PostsAdapter {
  modelNamePlural = 'postTemplates';
}
